module.exports = __webpack_public_path__ + "static/img/danyao-opt.cdb5373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/danyao-opt.png
// module id = PtBR
// module chunks = 3